import { render, staticRenderFns } from "./PaywayGroup.vue?vue&type=template&id=3b552a32&scoped=true"
import script from "./PaywayGroup.vue?vue&type=script&lang=js"
export * from "./PaywayGroup.vue?vue&type=script&lang=js"
import style0 from "./PaywayGroup.vue?vue&type=style&index=0&id=3b552a32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b552a32",
  null
  
)

export default component.exports